<ion-content [fullscreen]="true" class="walkthrough-page">
  <div class="wt">
    <!-- ===================== the bar =====================
         The WHOLE lockup is the link, exactly as the source has it, and it
         goes to Signup rather than to a marketing home page: there is no home
         page in this application. -->
    <header class="wt__bar">
      <a class="wt__lock" routerLink="/signup">
        <app-kz-brand-lockup
          [strapline]="'app.pages.auth.walkthrough.brand.strapline' | translate"
        ></app-kz-brand-lockup>
      </a>

      <div class="wt__barright">
        <app-kz-language-bar
          variant="pill"
          [languages]="languages"
          [activeLang]="lang()"
          [ariaLabel]="'app.pages.auth.walkthrough.aria.language' | translate"
          (langChange)="onLanguageChange($event)"
        ></app-kz-language-bar>

        <!-- Skip leaves for Signup from any pane. A real anchor, because it
             really does go somewhere — unlike Login's `Forgot password?`. -->
        <a class="wt__skip" routerLink="/signup">
          {{ 'app.pages.auth.walkthrough.skip' | translate }}
        </a>
      </div>
    </header>

    <!-- ===================== progress ===================== -->
    <app-walkthrough-dots
      [count]="paneCount"
      [current]="index()"
      [labels]="dotLabels()"
      (jump)="go($event)"
    ></app-walkthrough-dots>

    <!-- ===================== the stage =====================
         One card; the pane inside it changes. The source keeps all eight panes
         in the DOM and hides seven with `display:none`; this renders only the
         one on screen, which is the same picture with seven fewer subtrees. -->
    <div class="wt__stage">
      <div class="wt__slide">
        <!-- The panes are OnPush with no inputs, so a language switch would never re-check them.
             Keying the block on the language re-creates it (kz2 F1; the DS reads a lang signal
             inside each pane instead). -->
        @for (activeLang of [lang()]; track activeLang) {
          @switch (index()) {
            @case (0) {
              <app-walkthrough-pane1></app-walkthrough-pane1>
            }
            @case (1) {
              <app-walkthrough-pane2></app-walkthrough-pane2>
            }
            @case (2) {
              <app-walkthrough-pane3></app-walkthrough-pane3>
            }
            @case (3) {
              <app-walkthrough-pane4></app-walkthrough-pane4>
            }
            @case (4) {
              <app-walkthrough-pane5></app-walkthrough-pane5>
            }
            @case (5) {
              <app-walkthrough-pane6></app-walkthrough-pane6>
            }
            @case (6) {
              <app-walkthrough-pane7></app-walkthrough-pane7>
            }
            @case (7) {
              <app-walkthrough-pane8></app-walkthrough-pane8>
            }
          }
        }
      </div>
    </div>

    <!-- ===================== footer nav =====================
         Three children in DOM order count / prev / next. At `pane-nav` (700px)
         the counter takes `order: -1` and gains `min-width: 70px` while the row
         centres itself — one of ten declarations that flip together there.

         It does NOT "move from the right to the left": below 700 the counter is
         ALREADY leftmost, because `.btn.pri { flex: 1 }` eats the free space and
         `margin-left: auto` resolves to `0px`. The source behaves the same way.
         That prose was wrong in the spec too (auth.md §5.1, corrected in D39),
         and it is pinned now by `walkthrough-breakpoints.spec.ts`. -->
    <nav class="wt__nav">
      <span class="wt__count">
        {{
          'app.pages.auth.walkthrough.count'
            | translate: { current: index() + 1, total: paneCount }
        }}
      </span>

      <button
        class="wt__btn"
        type="button"
        [disabled]="index() === 0"
        [attr.aria-label]="'app.pages.auth.walkthrough.aria.previous' | translate"
        (click)="previous()"
      >
        <ion-icon name="arrow-back-outline" aria-hidden="true"></ion-icon>
      </button>

      <!-- The label flips on the last pane, and so does what the button does. -->
      <button class="wt__btn wt__btn--pri" type="button" (click)="next()">
        <span>
          {{
            (isLast()
              ? 'app.pages.auth.walkthrough.done'
              : 'app.pages.auth.walkthrough.next'
            ) | translate
          }}
        </span>
        <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
      </button>
    </nav>
  </div>
</ion-content>
